import { useEffect } from 'react';
import type { MutableRefObject } from 'react';

export const useCaptureClick = (
  ref: MutableRefObject<Element | null>,
  onClickedOnce: () => void,
): void => {
  useEffect(() => {
    ref.current?.addEventListener('click', onClickedOnce);
    return () => {
      ref.current?.removeEventListener('click', onClickedOnce);
    };
  }, [ref]);
};
